import {
    Button,
    Card,
    CardContent,
    CardMedia,
    InputLabel,
    List,
    ListItem,
    ListItemText,
    makeStyles,
} from "@material-ui/core";
import React, { useCallback, useEffect, useState } from "react";
import stockItemStyle from "./stockItemStyle";
import Box from "@material-ui/core/Box";
import {
    Remove as RemoveIcon,
    Add as AddIcon,
    Edit as EditIcon
} from "@material-ui/icons";
import { onlyNumber } from "../../utils/js/utilFunctions";
import { bindActionCreators } from "redux";
import { Creators as ProductActions } from "../../store/ducks/stock";
import { connect } from "react-redux";
import NotFoundImg from "../../assets/not-found.png";

const useStyles = makeStyles((theme) => stockItemStyle(theme));

const StockItem = ({ product, updateProduct }) => {
    const classes = useStyles();
    const [localProduct, setLocalProduct] = useState(product)
    const [value, setValue] = useState(product.estoque_atual)

    useEffect(() => setLocalProduct(product), [product, setLocalProduct])

    const onSave = useCallback(() => {
        updateProduct(value, localProduct)
    }, [value, updateProduct, localProduct])

    const incrementStock = () => {
        setValue(value + 1)
    }

    const decrementStock = () => {
        if (value <= 0) return ;
        setValue(value  - 1)
    }

    const handleInput = (value) => {
        if (isNaN(parseInt(value))) value = 0;
        setValue(parseInt(value))
    }

    const handleImageError = (event) => {
        event.target.src = NotFoundImg;
    }

    return (
        <Card className={classes.card}>
            <CardMedia
                component="img"
                onError={handleImageError}
                className={classes.cover}
                image={product.imagem}
                title={product.nome}
            />

            <CardContent className={classes.content}>
                <List
                    component="nav"
                    aria-label="main mailbox folders"
                    className={classes.productList}
                >
                    <ListItem className={classes.listItem}>
                        <ListItemText
                          primary="Nome:"
                          secondary={localProduct.nome}
                          className={classes.listItem}
                        />
                    </ListItem>

                    <ListItem className={classes.listItem}>
                        <ListItemText
                            primary="Código:"
                            secondary={localProduct.codigo}
                            className={classes.listItem}
                        />
                    </ListItem>

                    <ListItem className={classes.listItem}>
                        <ListItemText
                          primary="Preço:"
                          secondary={`R$ ${localProduct.preco}`}
                          className={classes.listItem}
                        />
                    </ListItem>

                    <ListItem className={classes.listItem}>
                        <ListItemText
                          primary="Preço de Custo:"
                          secondary={`R$ ${localProduct.preco_custo}`}
                          className={classes.listItem}
                        />
                    </ListItem>

                    <ListItem className={classes.listItem}>
                        <ListItemText
                          primary="Segmentos:"
                          secondary={localProduct.segmento?.join(', ')}
                          className={classes.listItem}
                        />
                    </ListItem>

                    <ListItem className={classes.listItem}>
                        <ListItemText
                            primary="Estoque mínimo:"
                            secondary={localProduct.estoque_minimo}
                            className={classes.listItem}
                        />
                    </ListItem>

                    <ListItem className={classes.listItem}>
                        <ListItemText
                            primary="Estoque atual:"
                            secondary={localProduct.estoque_atual}
                            className={classes.listItem}
                        />
                    </ListItem>

                    <ListItem className={classes.listItem}>
                        <ListItemText
                          primary="Compatibilidade:"
                          secondary={localProduct.compatibilidade?.join(', ')}
                          className={classes.listItem}
                        />
                    </ListItem>

                    <ListItem className={classes.listItem}>
                        <ListItemText
                          primary="Código fornecedor:"
                          secondary={localProduct.codigo_fornecedor}
                          className={classes.listItem}
                        />
                    </ListItem>

                    <ListItem className={classes.listItem}>
                        <ListItemText
                          primary="Localização:"
                          secondary={localProduct.localizacao}
                          className={classes.listItem}
                        />
                    </ListItem>
                </List>
            </CardContent>

            <Box className={classes.actions}>
                <Box >   
                    <InputLabel className={classes.currentStock}>Estoque atual:</InputLabel>
                </Box>
                <Box className={classes.stockActions}>
                    <Button
                      className={`${classes.button}`}
                      variant="contained"
                      startIcon={<RemoveIcon />}
                      onClick={decrementStock}
                    />

                    <input
                      className={classes.stockInput}
                      type="tel"
                      onChange={({target}) => handleInput(onlyNumber(target.value))}
                      value={value}
                    />

                    <Button
                      className={`${classes.button}`}
                      variant="contained"
                      startIcon={<AddIcon />}
                      onClick={incrementStock}
                    />
                </Box>

                <Button
                  className={classes.saveBtn}
                  variant="contained"
                  endIcon={<EditIcon />}
                  onClick={onSave}
                >Atualizar Estoque</Button>
            </Box>
        </Card>
    );
};

const mapStateToProps = () => ({});
const mapDispatchToProps = (dispatch) => {
    const { updateProduct } = ProductActions
    return bindActionCreators({ updateProduct }, dispatch);
};

export default connect(mapStateToProps, mapDispatchToProps)(StockItem)
